import { Voucher } from "@/lib/redux/features/voucher/type"

/** Số tiền hiển thị trên UI cho voucher AMOUNT (carousel, badge). */
export const getVoucherDisplayAmount = (voucher?: Voucher | null): number => {
  if (!voucher) return 0

  if (voucher.valueType === "PERCENT") {
    const pct = parseFloat(voucher.value || "0")
    return Number.isFinite(pct) ? pct : 0
  }

  const fromValue = parseFloat(voucher.value || "")
  if (Number.isFinite(fromValue) && fromValue > 0) return fromValue

  const fromDefault = parseFloat(voucher.defaultAmount || "")
  return Number.isFinite(fromDefault) ? fromDefault : 0
}

export const getVoucherMaxDiscountAmount = (voucher?: Voucher | null): number => {
  if (!voucher) return 0
  if (voucher.maxDiscountValue != null && voucher.maxDiscountValue > 0) {
    return voucher.maxDiscountValue
  }
  const fromDefault = parseFloat(voucher.defaultAmount || "")
  return Number.isFinite(fromDefault) ? fromDefault : 0
}

export const VOUCHER_CODE_TYPE = {
  PROMO_PUBLIC: "PROMO_PUBLIC",
  PROMO_IDENTIFY: "PROMO_IDENTIFY",
} as const

const flightProductType = (isDomestic: boolean) =>
  isDomestic ? "FLIGHTQN" : "FLIGHTQT"

const hasVoucherRemain = (v: Voucher) =>
  v.remainCounter == null || v.remainCounter > 0

const isFlightPromo = (v: Voucher, productType: string, codeType: string) =>
  v.isEnable !== false &&
  hasVoucherRemain(v) &&
  v.productType === productType &&
  v.voucherCodeType === codeType &&
  getVoucherDisplayAmount(v) > 0

/** Badge search: marketing — PROMO_IDENTIFY cao nhất */
export const pickSearchFlightBadgeVoucher = (
  vouchers: Voucher[],
  isDomestic: boolean,
): Voucher | null => {
  const productType = flightProductType(isDomestic)
  const candidates = vouchers.filter((v) =>
    isFlightPromo(v, productType, VOUCHER_CODE_TYPE.PROMO_IDENTIFY),
  )
  return candidates.reduce<Voucher | null>((best, v) => {
    if (!best) return v
    return getVoucherDisplayAmount(v) > getVoucherDisplayAmount(best) ? v : best
  }, null)
}

export const getAllowedPromoCodeType = (isAuthen: boolean) =>
  isAuthen ? VOUCHER_CODE_TYPE.PROMO_IDENTIFY : VOUCHER_CODE_TYPE.PROMO_PUBLIC

export const isVoucherAllowedForAuth = (
  voucher: Voucher | null | undefined,
  isAuthen: boolean,
): boolean => {
  if (!voucher) return false
  if (voucher.voucherCodeType === "CODE_SINGLE_USE_BALANCE") return true
  return voucher.voucherCodeType === getAllowedPromoCodeType(isAuthen)
}

/** Danh sách voucher checkout — lọc product + PROMO_PUBLIC/IDENTIFY theo login */
export const filterVouchersForBookingApply = (
  vouchers: Voucher[],
  productTypes: string[],
  isAuthen: boolean,
): Voucher[] =>
  vouchers.filter((v) => {
    if (v.voucherCodeType === "CODE_SINGLE_USE_BALANCE") return true
    if (productTypes.indexOf(v.productType) < 0) return false
    return isVoucherAllowedForAuth(v, isAuthen)
  })

/** Webview MWG/DLV — lọc voucher checkout (prod). */
export const filterVouchersForWebviewApply = (
  vouchers: Voucher[],
  productTypes: string[],
): Voucher[] =>
  vouchers.filter(
    (v) =>
      productTypes.indexOf(v.productType) > -1 ||
      v.voucherCodeType === "CODE_SINGLE_USE_BALANCE",
  )

/** Tự áp mã — chỉ voucher có condition AUTO_APPLY (normalize → autoApply). */
export const pickAutoApplyVoucher = (
  vouchers: Voucher[],
  productTypes: string[],
  isAuthen: boolean,
): Voucher | null =>
  vouchers.find(
    (v) =>
      v.autoApply === true &&
      v.isEnable !== false &&
      hasVoucherRemain(v) &&
      productTypes.indexOf(v.productType) > -1 &&
      isVoucherAllowedForAuth(v, isAuthen),
  ) ?? null

/** Booking: promo thật theo auth */
export const pickBookingFlightPromoVoucher = (
  vouchers: Voucher[],
  isDomestic: boolean,
  isAuthen: boolean,
): Voucher | null => {
  const productType = flightProductType(isDomestic)
  const codeType = getAllowedPromoCodeType(isAuthen)
  return vouchers.find((v) => isFlightPromo(v, productType, codeType)) ?? null
}
